module.exports = __webpack_public_path__ + "static/media/flower5.1801ae41.png";